export default __webpack_public_path__ + "static/media/form-edit-icon.d814eb13.svg";